import { render, staticRenderFns } from "./Stock-transfer.vue?vue&type=template&id=45e9bc48&scoped=true&"
import script from "./Stock-transfer.vue?vue&type=script&lang=js&"
export * from "./Stock-transfer.vue?vue&type=script&lang=js&"
import style0 from "./Stock-transfer.vue?vue&type=style&index=0&id=45e9bc48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e9bc48",
  null
  
)

export default component.exports